export const isLoading = (state) => state.verification.isLoading
export const isSuccess = (state) => state.verification.isSuccess
export const qr = (state) => state.verification.qr
export const qr_key = (state) => state.verification.qr_key

export const qr_status = (state) => state.verification.qr_status
export const isError = (state) => state.verification.error
